/**
 * Shared CNC (Click and Collect) URL validation logic
 * Used by both ufeApi.js and newAuthUfeApi.js to determine which endpoints
 * require defaultSAZipCode and defaultSACountryCode headers
 */

/* Reference: to build a regex refer this URL /api/checkout/profiles/4694170134046464/addresses?country=US */
export const CNC_API_INCLUDE_REGEX = new RegExp(
    '^/(?:api|v1)/(?:' +
        'checkout/profiles/[^/]+/addresses|' +
        'checkout/orders/current/samedaySchedules|' +
        'bi/profile/rewards|' +
        'bi/orders/[^/]+/rewards/[^/]+|' +
        'checkout/addresses|' +
        'checkout/afterpay/createCheckout|' +
        'checkout/klarna/createSession|' +
        'checkout/order/init|' +
        // Orders (dynamic)
        'checkout/orders/[^/]+|' +
        'checkout/orders/[^/]+/header|' +
        'checkout/orders/[^/]+/paymentGroups/[^/]+/giftCard|' +
        'checkout/orders/[^/]+/payments|' +
        'checkout/orders/[^/]+/shippingGroups/[^/]+|' +
        'checkout/orders/[^/]+/shippingGroups/[^/]+/shippingAddress|' +
        'checkout/orders/[^/]+/shippingGroups/[^/]+/shippingAddress/[^/]+|' +
        'checkout/orders/[^/]+/shippingGroups/[^/]+/shippingMethods|' +
        // Orders (static)
        'checkout/orders/altPickupPerson|' +
        'checkout/orders/digitalGiftMsg|' +
        'checkout/orders/paymentGroup|' +
        'checkout/orders/paymentGroups/giftCard|' +
        'checkout/orders/registerBi|' +
        'checkout/orders/shippingGroups/deliveryInstructions|' +
        'checkout/orders/shippingGroups/shippingAddress|' +
        'checkout/orders/shippingGroups/shippingMethod|' +
        'checkout/submitOrder|' +
        // Shopping cart
        'shopping-cart/basket|' +
        'shopping-cart/basket/items|' +
        'shopping-cart/basket/msgs|' +
        'shopping-cart/basket/promotions|' +
        'shopping-cart/basket/promotions/msgs|' +
        'shopping-cart/basket/samples|' +
        'shopping-cart/basket/switchItem|' +
        'shopping-cart/baskets/[^/]+/items/[^/]+|' +
        'shopping-cart/baskets/[^/]+/promotions|' +
        'shopping-cart/baskets/current/sddbopisitems|' +
        'shopping-cart/baskets/merge|' +
        // Util
        'util/shopping-cart/basket/itemsATG|' +
        'util/shopping-cart/cartDetails|' +
        'v3/util/samples' +
        ')(?:\\?.*)?$'
);

export const isCNCURL = apiEndpoint => {
    const parseURL = () => {
        try {
            return {
                path: new URL(apiEndpoint, window.location.origin).pathname
            };
        } catch (e) {
            Sephora.logger.warn('URL parsing failed for CNC check, falling back to regex. URL:', e);

            return { path: apiEndpoint };
        }
    };

    const { path } = parseURL();

    // Included intent patterns
    return CNC_API_INCLUDE_REGEX.test(path);
};
